import React, { useState, useEffect, useContext, useRef } from "react";
import "./index.css";
import Pickr from "@simonwep/pickr";
import "@simonwep/pickr/dist/themes/classic.min.css";
import "@simonwep/pickr/dist/themes/monolith.min.css";
import "@simonwep/pickr/dist/themes/nano.min.css";

// let pickr = null;

function RColorPicker(props) {
  const { color, changeColor, able = true, id, onOpen, onClose } = props;
  const pickrRef = useRef(null);
  const containerRef = useRef(null);
  const currentColor = useRef(color); // 新增 ref 存储当前颜色

  // 同步更新 ref 的值
  useEffect(() => {
    currentColor.current = color;
    //console.log("+++++", color);
  }, [color]);

  // 初始化创建实例
  useEffect(() => {
    if (able && !pickrRef.current) {
      pickrRef.current = new Pickr({
        el: containerRef.current,
        theme: "nano",
        default: color || "#FFFFFF",
        swatches: [
          "rgba(244, 67, 54)",
          "rgba(233, 30, 99)",
          "rgba(156, 39, 176)",
          "rgba(103, 58, 183)",
          "rgba(63, 81, 181)",
          "rgba(33, 150, 243)",
          "rgba(3, 169, 244)",
          "rgba(0, 188, 212)",
          "rgba(0, 150, 136)",
          "rgba(76, 175, 80)",
          "rgba(139, 195, 74)",
          "rgba(205, 220, 57)",
          "rgba(255, 235, 59)",
          "rgba(255, 193, 7)",
        ],
        components: {
          // Main components
          preview: true,
          opacity: false,
          hue: true,
          // Input / output Options
          interaction: {
            hex: true,
            // rgba: true,
            // hsla: true,
            // hsva: true,
            // cmyk: true,
            input: true,
            clear: false,
            save: true,
          },
        },
      });

      pickrRef.current.on("save", (color, instance) => {
        if (color) {
          const newColor = color.toHEXA().toString();
          if (newColor !== currentColor.current) {
            changeColor(newColor);
          }

          pickrRef.current.hide();
        }
      });

      // 添加show/hide事件监听
      pickrRef.current
        .on("show", () => onOpen && onOpen())
        .on("hide", () => onClose && onClose());
    }

    return () => {
      if (pickrRef.current) {
        pickrRef.current.destroy();
        pickrRef.current = null;
      }
    };
  }, [able]);

  useEffect(() => {
    // 外部颜色变化同步更新pickr实例
    //console.log('----', color, containerRef.current, id)
    if (color && pickrRef.current) {
      // 添加精确的颜色格式比较
      const pickrColor = pickrRef.current
        .getColor()
        .toHEXA()
        .toString()
        .toLowerCase();
      // console.log('pickrColor-', pickrColor)
      const inputColor = color.startsWith("#")
        ? color.toLowerCase()
        : `#${color.toLowerCase()}`;

      if (inputColor !== pickrColor) {
        pickrRef.current.setColor(inputColor);
      }
    }
  }, [color]);

  return (
    <div
      id={id}
      className={`r-color-initPicker ${able ? "" : "disabled"}`}
      style={{ background: color ? color : "#FFFFFF" }}
      onClick={(e) => {
        e.stopPropagation(); // 阻止事件冒泡
        if (able && pickrRef.current) {
          pickrRef.current.show();
        }
      }}
    >
      <div ref={containerRef} className={`r-color-pickr`}></div>
    </div>
  );
}

export default RColorPicker;
